<template>
  <div>
    <input-select-modal
      :title="$t('group.addUserModal.header')"
      :okButton="$t('commons.save')"
      :cancelButton="$t('commons.cancel')"
      :error="showError"
      :errorMessage="$t('group.addUserModal.userNotSelectedError')"
      :label="$t('group.addUserModal.user')"
      :options="options()"
      v-on:cancel="onCancel"
      v-on:ok="onAccept"
      v-model="selected"
      :searchable="true">
    </input-select-modal>
  </div>
</template>

<script>
import Checkbox from '../shared/forms/Checkbox';
import InputSelectModal from '../shared/dialogs/InputSelectModal';

export default {
  name: 'AddUserModal',
  components: {
    InputSelectModal,
    Checkbox
  },
  props: {
    users: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      showError: false,
      selected: undefined
    };
  },
  methods: {
    onCancel (event) {
      this.$emit('cancel', event);
    },
    onAccept (event) {
      if (!this.selected) {
        this.showError = true;
        return;
      }
      this.showError = false;
      this.$emit('addUser', this.selected.value);
    },
    options () {
      return this.users.map(user => ({
        label: user.name,
        value: user
      }));
    }
  }
};
</script>

<style lang="scss" scoped>
  @import "../../stylesheets/variables.scss";
  .inline {
    display: inline;
  }

  .error-message {
    color: $error;
  }
</style>



// WEBPACK FOOTER //
// src/components/group/AddUserModal.vue